import { pipe, map } from "rxjs"
import { BusinessSector } from "src/app/core/models/common/business-sector.model"
import { BusinessSectorDto } from "src/app/infrastructure/lobby-proxy/DTOs/business-sector.dto"


export const mapBusinessSectorDtoToBusinessSector = pipe(
    map((source: BusinessSectorDto) => businessSectorDtoToBusinessSector(source))
)

export function businessSectorDtoToBusinessSector(source: BusinessSectorDto): BusinessSector | null {
    if (!source) return null
    return {
        id: source.businessSectorId,
        description: source.description,
        atecoCode: source.atecoCode,

        created: new Date(source.created),
        updated: new Date(source.updated),
        deleted: source.deleted ? new Date(source.deleted) : null,

        version: source.version
    }
}